<div class="confirm-status">
  <div class="icon-content">
    <div class="icon">
      <mat-icon>check</mat-icon>
    </div>
  </div>
  <div class="text-center mt-4">
    <h5 class="title">{{title}}</h5>
    <label class="mt-1">{{message}}</label>
    <div class="row mt-2">
      <div class="col-6">
        <button class="btn btn-primary w-75" (click)="accept()">Si</button>
      </div>
      <div class="col-6">
        <button class="btn btn-secondary w-75" mat-dialog-close>No</button>
      </div>
    </div>
  </div>
</div>